import { logo, archLogo } from 'assets/images';
import logoAnimated from 'assets/images/eAtlas_Animated.gif';
import archlogoAnimated from 'assets/images/arch_Animated.gif';

const config = {
  eAtlas: {
    logo,
    name: 'eAtlas',
    loadingIndicator: logoAnimated,
  },
  Arch: {
    logo: archLogo,
    name: 'Arch',
    loadingIndicator: archlogoAnimated,
  },
};

export const appConfig = config[process.env.REACT_APP_BRANDING];
